import {
  Injectable
} from '@angular/core';
import {
  Observable
  ,
  BehaviorSubject
  ,
  Subscription
} from 'rxjs';

import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {ApiService} from '../../../../services/api';
import {UserContext} from '../../../../services/user-context';

@Injectable()
export class ExportClientsService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService, private userContext: UserContext) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }


  public getAllClients(start: string, end: string, search?: string): Observable<any[]> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', '1')
      .set('limit', '10000')
      .set('start', start)
      .set('end', end)
      .set('account', this.userContext.isAdministrator() && this.userContext.account ? this.userContext.account.id : '');

    return this.api.get<any>('/client', params);
  }

  public getClients(start: string, end: string, page: number, limit: number, cb?: any, search?: string) {
    const params = new HttpParams()
      .set('page', page.toLocaleString())
      .set('limit', limit.toString())
      .set('search', search)
      .set('start', start)
      .set('end', end)
      .set('account', this.userContext.isAdministrator() && this.userContext.account ? this.userContext.account.id : '');

    this.subscription = this.api.get<GridDataResult>('/client', params)
      .subscribe(result => {
        super.next(result);
        if(cb) {
          cb();
        }
      }, error => {
        if(cb) {
          cb();
        }
      });
  }
}
